export enum EMarque {
    Olympus = 1,
    Pentax = 2,
    FujinonFujifilm = 3,
    KarlStorz = 4,
    Wolf = 5,
    Autre = 6
}